/* eslint-disable no-undef */
import React, { Component } from "react";
import mapStyle from "../../../config/mapStyle";
import TrackingArtwork from "../trackingArtwork";

const BOARDING_ZOOM_LEVEL = 14;
const BOARDING_PIN =
  "M9 0C4.035 0 0 4.00972 0 8.94362C0 11.9546 1.755 14.4738 3.795 16.2327C4.44 16.7842 5.565 17.6636 6.57 18.9605C7.68 20.4064 8.685 21.9566 9 23C9.315 21.9566 10.32 20.4064 11.43 18.9605C12.435 17.6636 13.56 16.7842 14.205 16.2327C16.245 14.4738 18 11.9546 18 8.94362C18 4.00972 13.965 0 9 0ZM9 3.81594C9.67762 3.81594 10.3486 3.94857 10.9746 4.20626C11.6007 4.46395 12.1695 4.84166 12.6487 5.3178C13.1278 5.79395 13.5079 6.35922 13.7672 6.98134C14.0265 7.60346 14.16 8.27024 14.16 8.94362C14.16 9.61699 14.0265 10.2838 13.7672 10.9059C13.5079 11.528 13.1278 12.0933 12.6487 12.5694C12.1695 13.0456 11.6007 13.4233 10.9746 13.681C10.3486 13.9387 9.67762 14.0713 9 14.0713C7.63148 14.0713 6.31902 13.5311 5.35133 12.5694C4.38364 11.6078 3.84 10.3036 3.84 8.94362C3.84 7.58367 4.38364 6.27943 5.35133 5.3178C6.31902 4.35618 7.63148 3.81594 9 3.81594Z";

const isCoordinate = value => typeof value === "number" && isFinite(value);

// Shown before tracking goes live: there is no bus feed yet, so the map just
// anchors the customer on their boarding point.
class PreTripMap extends Component {
  componentDidMount() {
    if (this.canRenderMap()) {
      this.initMap();
    }
  }

  // A boarding point without usable coordinates (a station whose opposite side
  // was never mapped) would leave an empty grey map container behind, so fall
  // back to the artwork instead of mounting the map at all.
  canRenderMap = () => {
    const { boardingPoint } = this.props.booking;

    return (
      typeof google !== "undefined" &&
      isCoordinate(boardingPoint && boardingPoint.lat) &&
      isCoordinate(boardingPoint && boardingPoint.lng)
    );
  };

  initMap = () => {
    try {
      const { boardingPoint } = this.props.booking;
      const center = { lat: boardingPoint.lat, lng: boardingPoint.lng };

      this.map = new google.maps.Map(document.getElementById("map"), {
        zoom: BOARDING_ZOOM_LEVEL,
        center,
        disableDefaultUI: true,
        gestureHandling: "greedy"
      });

      const styledMapType = new google.maps.StyledMapType(mapStyle);
      this.map.mapTypes.set("styled_map", styledMapType);
      this.map.setMapTypeId("styled_map");

      const marker = new google.maps.Marker({
        position: center,
        map: this.map,
        zIndex: 100,
        icon: {
          path: BOARDING_PIN,
          fillColor: "green",
          fillOpacity: 5.0,
          strokeColor: "white",
          anchor: new google.maps.Point(12, 25),
          scale: 1
        }
      });

      const infoWindow = new google.maps.InfoWindow({
        content:
          `<div class="infoWindowBoardingHeader">Boarding Point</div>` +
          `<div class="infoWindowContent">${boardingPoint.name}</div>`,
        disableAutoPan: true
      });

      infoWindow.open(this.map, marker);

      marker.addListener("click", () => {
        infoWindow.open(this.map, marker);
      });
    } catch (err) {
      console.log(err);
    }
  };

  render() {
    if (!this.canRenderMap()) {
      return (
        <TrackingArtwork
          isMaxService={this.props.booking?.trip?.service?.isMaxService}
          title="Tracking Unavailable"
          subtitle="Please refresh again later"
        />
      );
    }

    return <div style={{ width: "100%", height: "50vh" }} id="map" />;
  }
}

export default PreTripMap;
